import classNames from 'classnames/bind';
import parse, {
  attributesToProps,
  domToReact,
  HTMLReactParserOptions,
} from 'html-react-parser';
import { useRouter } from 'next/router';
import styles from './index.module.scss';

export interface TextProps {
  id?: any;
  text?: string;
  children?: string;
  [key: string]: any;
}

export const Text = ({ id, text, children, ...rest }: TextProps) => {
  const cx = classNames.bind(styles);

  const { query } = useRouter();
  const params = new URLSearchParams(JSON.parse(JSON.stringify(query)));
  const paramsString = params.toString();

  const options: HTMLReactParserOptions = {
    replace: (domNode: any) => {
      if (
        domNode.name === 'a' &&
        domNode.attribs &&
        !domNode.attribs.href.startsWith('mailto:')
      ) {
        const props = attributesToProps(domNode.attribs);
        return (
          <a
            {...props}
            href={`/${id}/outbound?url=${encodeURIComponent(
              domNode.attribs.href,
            )}&${paramsString}`}
            rel="noopener noreferrer"
            target="_blank"
          >
            {domToReact(domNode.children, options)}
          </a>
        );
      }
    },
  };

  return (
    <section className={cx('component', 'text', rest)}>
      {(!!text || !!children) && parse(text || children || '', options)}
    </section>
  );
};

Text.defaultProps = {
  text: '',
} as Partial<TextProps>;
